import React from "react"
import { AppLink } from "@ecom/ui/components/AppLink"
import { ISingleCard } from "../types"
import * as styles from "./seoCard.module.scss"

export const SeoCard: React.FC<{ card: ISingleCard }> = ({ card }) => {
  const { title, description, moreDetails, moreDetailsTitle, ctaButton, ctaButtonTitle, image } =
    card

  return (
    <div className={styles.card}>
      <div className={styles.adaptiveBlock}>
        <img src={image} className={styles.img} alt="card" />
        <div className={styles.textBlock}>
          <div>
            <p className={styles.title}>{title}</p>
          </div>
          <div className={styles.description}>{description}</div>
        </div>
      </div>
      <div className={styles.btnGroup}>
        {moreDetails && moreDetailsTitle && (
          <AppLink
            href={moreDetails}
            target="_blank"
            rel="noreferrer"
            className={styles.btnSecondary}
          >
            {moreDetailsTitle}
          </AppLink>
        )}
        {ctaButton && ctaButtonTitle && (
          <AppLink href={ctaButton} target="_blank" rel="noreferrer" className={styles.btnPrimary}>
            {ctaButtonTitle}
          </AppLink>
        )}
      </div>
    </div>
  )
}
